// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-next-module--wrapper--14981","icon":"carousel-next-module--icon--b3736"};